// extracted by mini-css-extract-plugin
module.exports = {"colored":"Template_colored__3WgNB","linklist":"Template_linklist__2L_HN"};